import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-inline ms-2" };
const _hoisted_2 = { class: "modal-title w-100 text-center fw-bold fs-4 mb-4" };
const _hoisted_3 = { class: "form-check mb-3" };
const _hoisted_4 = ["id"];
const _hoisted_5 = ["for"];
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = ["id", "placeholder"];
const _hoisted_8 = ["for"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = { class: "ms-2" };
import { onMounted, ref, watch } from 'vue';
import axios from 'axios';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FillLineOptionManager',
    props: {
        configurationComponentId: String
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const instanceId = Math.random().toString(36).substring(2, 7);
        const contactEmail = ref('');
        const loading = ref(false);
        const configuredFillLineOption = ref(false);
        const configuredFillLineOptionText = ref('');
        const saved = ref(false);
        const modal = ref();
        onMounted(async () => {
            load();
            contactEmail.value = await loadTenantConfigs('mail_contact');
        });
        watch([configuredFillLineOption, configuredFillLineOptionText], () => {
            saved.value = false;
        });
        function load() {
            axios.post(route('configurator.bottleConfiguration.loadFillLineOption', props.configurationComponentId)).then(function (response) {
                configuredFillLineOption.value = response.data.hasFillLinePrint;
                configuredFillLineOptionText.value = response.data.fillLinePrintText;
                emit('update', {
                    hasFillLinePrint: configuredFillLineOption.value,
                    fillLinePrintText: configuredFillLineOptionText.value
                });
                if (configuredFillLineOption.value || configuredFillLineOptionText.value) {
                    setTimeout(() => {
                        saved.value = true;
                    }, 500);
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function update() {
            loading.value = true;
            saved.value = false;
            axios.put(route('configurator.bottleConfiguration.updateFillLineOption', props.configurationComponentId), {
                hasFillLinePrint: configuredFillLineOption.value,
                fillLinePrintText: configuredFillLineOptionText.value
            }).then(function () {
                loading.value = false;
                saved.value = true;
                modal.value.close();
                emit('update', {
                    hasFillLinePrint: configuredFillLineOption.value,
                    fillLinePrintText: configuredFillLineOptionText.value
                });
            })
                .catch(function (error) {
                console.log(error);
                loading.value = false;
                saved.value = false;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: "btn btn-primary d-inline-flex align-items-center m-2",
                    onClick: _cache[0] || (_cache[0] = ($event) => (modal.value.open($event)))
                }, [
                    _cache[4] || (_cache[4] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-dash-lg",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"
                        })
                    ], -1)),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('Eichstrich')), 1)
                ]),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    id: 'fillLineOptionModal' + _unref(instanceId),
                    zIndex: 1050,
                    size: 'sm'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('Eichstrich')), 1),
                        _createElementVNode("div", null, [
                            _createElementVNode("form", {
                                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (update()), ["prevent"]))
                            }, [
                                _createElementVNode("div", _hoisted_3, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        value: "1",
                                        id: 'fillLineOptionSet-' + _unref(instanceId),
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((configuredFillLineOption).value = $event))
                                    }, null, 8, _hoisted_4), [
                                        [_vModelCheckbox, configuredFillLineOption.value]
                                    ]),
                                    _createElementVNode("label", {
                                        class: "form-check-label",
                                        for: 'fillLineOptionSet-' + _unref(instanceId)
                                    }, _toDisplayString(_unref(t)('Eichstrich drucken')), 9, _hoisted_5)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: 'fillLineOptionText-' + _unref(instanceId),
                                        placeholder: _unref(t)('Füllvolumen in l'),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((configuredFillLineOptionText).value = $event)),
                                        required: ""
                                    }, null, 8, _hoisted_7), [
                                        [_vModelText, configuredFillLineOptionText.value]
                                    ]),
                                    _createElementVNode("label", {
                                        for: 'fillLineOptionText-' + _unref(instanceId)
                                    }, _toDisplayString(_unref(t)('Füllvolumen in l')), 9, _hoisted_8)
                                ]),
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "btn btn-primary d-inline-flex align-items-center mb-4",
                                    disabled: loading.value
                                }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        class: "bi bi-check2",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(saved.value ? _unref(t)('Gespeichert') : _unref(t)('Speichern')), 1)
                                ], 8, _hoisted_9)
                            ], 32)
                        ])
                    ]),
                    _: 1
                }, 8, ["id"])
            ], 64));
        };
    }
});
